export interface LetterRequestCustomer_Device_Interface {
  id:number,

  device_id:Number,
  device_name:String,
  device_name_en:String,

  dsc_bazgast:String,

  gostareh:String,
  calibration_detail_id:number,

  location_id:Number,
  location_name:String,

  expiration:Number,
  expiration_title:String,

  tedad:number,
  incPercentModir:number,
  incRailModir:number,

  price_id:number,
  price:number,
  price_dsc:String,

  dsc:String,
  username:String,
  persianDate:String,
  dscUser:String,
  dscMission:String,

  del:boolean,
  dscVisible:boolean,

  deviceCode:String,
  deviceSerial:String,
  deviceCustomerDsc: String,

  modirEdit:boolean,

  file:Array<string>
}

export function Empty_LetterRequestCustomer_Device_Interface():LetterRequestCustomer_Device_Interface{
  return{
    id:0,

    device_id:0,
    device_name:'',
    device_name_en:'',

    gostareh:'',
    calibration_detail_id:0,

    location_id:0,
    location_name:'',

    expiration:0,
    expiration_title:'',

    dscUser:'',
    dscMission:'',
    tedad:0,
    incPercentModir:0,
    incRailModir:0,

    price_id:0,
    price:0,
    price_dsc:'',

    dsc_bazgast:'',

    dsc:'',
    username:'',
    persianDate:'',

    del:false,
    dscVisible:false,

    modirEdit: false,

    deviceCode:'',
    deviceSerial:'',
    deviceCustomerDsc:'',

    file:[]
  }
}
